import { Injectable } from '@angular/core';
import { ApiEnum } from '../enumerators/enumerators.enum';
import { environment } from '../../environments/environment';
import { Config } from '../models/config.model';
import {} from 'crypto-js';
import { AppService } from './app.service';


@Injectable()
export class ConfigService {
    public config: Config;


    constructor( ) {
        this.config =
        {
            securityAPI: this.getURLBase(),
            secret: 'SDBtMzFuNzNyMW9SMi5zMHMxLjFuQzNQdDFvLkg0c1ByMzJ1UHUzc1QwMg==',
            version: "1.0.1"
        };
    }

    getURLBase() {
        return environment.apiURL;
    }


    setURLBase(api: ApiEnum) {
        switch (api) {
            case ApiEnum.Security:
                this.config.securityAPI = this.getURLBase();
                this.config.servicesAPI = '';
                break;

            case ApiEnum.Rest:
                this.config.securityAPI = localStorage.getItem('AOT')!;
                this.config.servicesAPI = localStorage.getItem('Servicios')!;
                break;
            default:
                break;
        }
    }
}
